import { render, staticRenderFns } from "./Coupon-Edit.vue?vue&type=template&id=2e45887a&"
import script from "./Coupon-Edit.vue?vue&type=script&lang=js&"
export * from "./Coupon-Edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports